import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user } = useAuth();

  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background" data-testid="auth-checking">
        <p className="text-muted-foreground text-lg">Loading…</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  if (adminOnly && user.platform_role !== "platform_admin") return <Navigate to="/dashboard" replace />;
  return children;
};
